import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export const DoughnutGraph = ({ data, isMobile }) => {
    const options = { indexAxis: 'x', maintainAspectRatio: !isMobile }

    return <Doughnut data={data} options={options} />
}
